import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../services/common.service';

@Component({
    selector: 'app-autocomplete-cp-ville',
    templateUrl: './autocomplete-cp-ville.component.html',
    styleUrls: ['./autocomplete-cp-ville.component.css'],
    standalone: false
})
export class AutocompleteCpVilleComponent implements OnInit {
  @Input() label;
  @Input() material: Boolean = false;
  @Input() cp;
  @Input() ville;
  @Input() iscp: Boolean;
  @Input() item;
  @Input() disable: Boolean;
  @Input() container: Boolean;
  @Input() isEcoPortail: Boolean
  @Input() needId: Boolean;
  @Input() userEcoPortail;
  @Input() class;
  @Input() placeholder;
  @Input() deleteSelectedValue: boolean;
  @Input() activeVisibleChamp: boolean;
  @Input() visibleChamp: boolean;
  @Input() cpChantier: boolean;
  @Input() dropdownclass: String;
  @Output() blurfunction = new EventEmitter<any>();
  @Output() keyenterfunction = new EventEmitter<String>();
  @Output() valueChanged = new EventEmitter<any>();
  resultCpVille: any[] = [];
  status: { isopen: boolean } = { isopen: false };
  search = '';

  constructor(public common: CommonService) {
  }

  ngOnInit() {
    this.placeholder = this.placeholder || '';
    if (!this.label) {
      this.label = '';
    }
  }

  searchCPVille(event) {
    if (this.isEcoPortail) {
      this.searchCPVilleEcoPortail(event);
    } else {
      this.searchCPVilleEcorec(event);
    }
  }

  searchCPVilleEcoPortail(event) {
    if (this.iscp) {
      this.item[this.cp] = event
    } else {
      this.item[this.ville] = event
    }
    if (event) {
      this.common.getEcoportail(`${this.common.reformeNomClient(this.userEcoPortail)
        }/demande/getcpv/${this.iscp ? 'parcp' : 'parville'}/${event}`).then(datas => {
          // $('#autocomplete').trigger('click');
          this.resultCpVille = datas;
        });
    } else {
      this.resultCpVille = [];
    }
  }

  searchCPVilleEcorec(event) {
    if (this.iscp) {
      this.item[this.cp] = event
    } else {
      this.item[this.ville] = event
    }
    this.resultCpVille = [];
    const param = {
      'servlet': this.iscp ? 'DBCodePostalVilleGetListParCP' : 'DBCodePostalVilleGetListParVille',
      'module': 'Recylog',
      'type': 'string',
      'compression': 'false',
      'data': event
    };

    this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      this.resultCpVille = datas.data;
    });
  }

  selectAdresse(item) {
    if (item) {
      if (this.cp) {
        this.item[this.cp] = item.codePostal;
      }
      if (this.ville) {
        this.item[this.ville] = item.ville;
      }

      if (this.isEcoPortail) {
        this.item['id'] = item.id;
      }
      if (this.needId) {
        this.item['id'] = item.id;
      }
      this.valueChanged.emit(this.cpChantier ? item : '');
    } else {
      if (this.cp) {
        this.item[this.cp] = '';
      }
      if (this.ville) {
        this.item[this.ville] = '';
      }
      this.valueChanged.emit(this.cpChantier ? item : '');
    }
  }

  blurfct() {
    this.blurfunction.emit();
  }

  keyEnter() {
    this.keyenterfunction.emit();
  }

}
